import axios from 'axios'

const defaultHeaders = {
  'Content-Type': 'application/json',
}

const axiosClient = axios.create({
  headers: {
    get: defaultHeaders,
    post: defaultHeaders,
    put: defaultHeaders,
    delete: defaultHeaders,
    options: defaultHeaders,
  },
})

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
)

export default axiosClient
